import type { FC } from "react";
import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { toolHasActivePeriodicPurchaseInstructions } from "web_myplann/Portfolio/Helpers/activePurchaseInstructions";
import type {
	ToolKind,
	ToolRowCommonProps,
} from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import { getPortfolioFrequencyValue } from "web_myplann/Portfolio/Helpers/portfolioDetailFormatters";
import { useToolSummary } from "web_myplann/Portfolio/Helpers/useToolSummary";
import { DataRow } from "web_myplann/Shared/Components/DataRow";
import { ToolRowWrapper } from "./ToolRowWrapper";

const PageResources = Resources.PortfolioDetail;

export const CommodityToolRow: FC<
	ToolRowCommonProps<typeof ToolKind.Commodity>
> = ({
	tool,
	portfolioId,
	currencySign,
	toolsSummary,
	expanded,
	onToggle,
	noDivider,
}) => {
	const { t } = useResource();
	const { totalValue, totalInvested } = useToolSummary(tool.id, toolsSummary);

	const hasActivePurchases = toolHasActivePeriodicPurchaseInstructions(tool);
	const shouldShowRegularPayment =
		hasActivePurchases && tool.monthlyPayment > 0;

	return (
		<ToolRowWrapper
			label={`${tool.name} (${tool.identification})`}
			totalValue={totalValue}
			expanded={expanded}
			onToggle={onToggle}
			noDivider={noDivider}
			portfolioId={portfolioId}
			historyTarget={{ toolId: tool.id }}
		>
			{shouldShowRegularPayment && (
				<DataRow
					label={t(PageResources.SharedLabels.recurringPayment)}
					value={getPortfolioFrequencyValue(
						tool.monthlyPayment,
						currencySign,
						ClientPortfolioPaymentFrequencyEnum.Monthly,
						t,
						0,
					)}
				/>
			)}
			<DataRow
				label={t(PageResources.SharedLabels.investedAll)}
				value={totalInvested}
			/>
			<DataRow
				label={t(PageResources.SharedLabels.currentValue)}
				value={totalValue}
			/>
		</ToolRowWrapper>
	);
};
